import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { parseUrl } from '@mssgme/helpers';
import { hex2rgb } from '@mssgme/lib';
import { useExperiments, useNavigationUtils, useRestrictedCard } from '@mssgme/hooks';
import { NavBackButton, ScrollableBox, SidebarHeader } from '@mssgme/ui';
import ListItem from './ListItem';
import { PageLayout } from '../../../UI';

import styles from './styles.scss';

export function PageEditMenu() {
    const { t } = useTranslation('cards');
    const { generateUrl } = useNavigationUtils();
    const restrictedCard = useRestrictedCard();
    const {
        profile: { website, description, fullname },
        design: { photoUrl, background },
        messengers,
        links,
    } = restrictedCard;
    const { isLinksDisplayed } = useExperiments();
    const parsedWebsiteUrl = website.url ? parseUrl(website.url) : null;
    const noProtocolWebsiteUrl = parsedWebsiteUrl
        ? parsedWebsiteUrl.hostname + (parsedWebsiteUrl.pathname === '/' ? '' : parsedWebsiteUrl.pathname)
        : null;
    const bgColor =
        background.type === 'color'
            ? `linear-gradient(135deg, rgba(${hex2rgb(background.color)}, 1) 0%, rgba(${hex2rgb(
                background.color
            )}, .6) 100%)`
            : 'none';

    return (
        <PageLayout>
            <SidebarHeader heading={t('PageEditMenu.title')} leftButton={<NavBackButton to={generateUrl('..')} />} />
            <ScrollableBox className={styles.scrollBox}>
                <ul className={styles.list}>
                    <ListItem to={generateUrl('avatar')} name={t('PageEditMenu.menu.avatar')}>
                        <div className={styles.previewImg}>
                            <img src={photoUrl} alt={fullname} />
                        </div>
                    </ListItem>
                    <ListItem to={generateUrl('cover')} name={t('PageEditMenu.menu.cover')}>
                        <div className={cn(styles.previewImg, styles.square)} style={{ backgroundImage: bgColor }}>
                            {background.type === 'image' && <img src={background.imageUrl} alt="cover" />}
                        </div>
                    </ListItem>
                    <ListItem to={generateUrl('title')} name={t('PageEditMenu.menu.title')}>
                        <div className={styles.textPreview}>{fullname || t('PageEditMenu.values.empty')}</div>
                    </ListItem>
                    <ListItem to={generateUrl('description')} name={t('PageEditMenu.menu.description')}>
                        <div className={styles.textPreview}>{description || t('PageEditMenu.values.empty')}</div>
                    </ListItem>
                    <ListItem to={generateUrl('messengers')} name={t('PageEditMenu.menu.messengers')}>
                        <div className={styles.textPreview}>{messengers.filter((i) => i.enabled).length}</div>
                    </ListItem>
                    {isLinksDisplayed && (
                        <ListItem to={generateUrl('links')} name={t('PageEditMenu.menu.links')}>
                            <div className={styles.textPreview}>{links.filter((i) => i.enabled).length}</div>
                        </ListItem>
                    )}
                    <ListItem to={generateUrl('website')} name={t('PageEditMenu.menu.website')}>
                        <div className={styles.textPreview}>
                            {website.enabled && website.url && noProtocolWebsiteUrl}
                            {!website.enabled && website.url && t('PageEditMenu.values.off')}
                            {!website.url && t('PageEditMenu.values.empty')}
                        </div>
                    </ListItem>
                </ul>
            </ScrollableBox>
        </PageLayout>
    );
}
